import React from "react";
import Navigation from "../../../components/Navigation";
import CreateTutorialForm from "./CreateTutorialForm";

const CreateTutorial = () => {
  return (
    <div className="bg-[#F7F7F7] calc-h-header">
      <Navigation />

      <CreateTutorialForm />
    </div>
  );
};

export default CreateTutorial;